import React, { useState } from 'react'
import {
  BundlesFeaturesShowHide,
  BundleShowHideFeaturesList,
  ToggleWithTextWrapper,
} from 'Features/pricing/tabs/Bundles/Bundle.styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/pro-light-svg-icons'
import { ToggleWithText } from '@clickcease/cc-client-components-lib'
import { PlanFeaturesTable } from 'Features/pricing/components/PlanFeaturesTable/PlanFeaturesTable'
import { BotMitigationTableData } from 'Features/pricing/tabs/BotMitigation/BotMitigationTableData'
import { PaidMarketingTableData } from 'Features/pricing/tabs/PaidMarketing/PaidMarketingTableData'
import { BundlesFeaturesWrapperStyled } from 'Features/pricing/tabs/Bundles/BundlesFeaturesWrapper/BundlesFeaturesWrapper.styled'
import { useTranslation } from 'react-i18next'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

export const BundlesFeaturesWrapper = () => {
  const { t } = useTranslation('pricing')
  const [showFeatureTable, setShowFeatureTable] = useState<boolean>(false)
  const [featureTableToShow, setFeatureTableToShow] = useState<boolean>(false)
  return (
    <BundlesFeaturesWrapperStyled>
      <BundlesFeaturesShowHide>
        <BundleShowHideFeaturesList onClick={() => setShowFeatureTable(!showFeatureTable)}>
          {t('bundles.complete_features_list')}
          <FontAwesomeIcon
            icon={showFeatureTable ? (faChevronUp as IconProp) : (faChevronDown as IconProp)}
            style={{ marginLeft: '15px', height: '11px' }}
          />
        </BundleShowHideFeaturesList>
      </BundlesFeaturesShowHide>
      {showFeatureTable && (
        <>
          <ToggleWithTextWrapper>
            <ToggleWithText
              css={{ width: '300px' }}
              onChange={(value) => {
                setFeatureTableToShow(!value)
              }}
              value={featureTableToShow}
              text1={t('bundles.paid_marketing_no_colon')}
              text2={t('bundles.bot_mitigation')}
            ></ToggleWithText>
          </ToggleWithTextWrapper>
          <PlanFeaturesTable
            data={featureTableToShow ? BotMitigationTableData : PaidMarketingTableData}
          />
        </>
      )}
    </BundlesFeaturesWrapperStyled>
  )
}
